import { Component, OnDestroy, OnInit } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { GeneralService } from "app/services/general.service";
import { HreflangService } from "app/services/hreflang.service";
import { Equipment } from "app/shared/equipment";
import { Observable, Subscription, of } from "rxjs";
import { catchError, shareReplay } from "rxjs/operators";

@Component({
  selector: "app-equipment_categories",
  templateUrl: "./equipment_categories.component.html",
  styleUrls: ["./equipment_categories.component.scss"],
})
export class EquipmentCategoriesComponent implements OnInit, OnDestroy {
  equipment$!: Observable<Equipment[]>;
  activeLang: string = "EN";
  firstRun = false;
  private langChangesSubscription!: Subscription;

  errorMsg: string | null = null;

  constructor(
    public router: ActivatedRoute,
    private _translocoService: TranslocoService,
    private meta: Meta,
    private hreflangService: HreflangService,
    private generalService: GeneralService
  ) {}

  ngOnInit(): void {
    this.getEquipmentsData();
    this.getActiveLang();
  }

  getActiveLang() {
    this.langChangesSubscription =
      this._translocoService.langChanges$.subscribe((activeLang) => {
        if (this.activeLang !== activeLang || !this.firstRun) {
          this.deleteSchemaMeta();
          setTimeout(() => {
            this.hreflangService.updateHreflangTags(
              activeLang,
              "equipment_categories"
            );
          }, 1000);
          this.firstRun = true;
        }
        this.activeLang = activeLang;
      });
  }

  getEquipmentsData() {
    // المهم: نستخدم Observable + async في القالب
    this.equipment$ = this.generalService.getItems("main_category").pipe(
      catchError((err) => {
        this.errorMsg = (err && (err.message || err.statusText)) || "Error";
        return of([] as Equipment[]);
      }),
      shareReplay(1)
    );
  }

  ngOnDestroy() {
    if (this.langChangesSubscription)
      this.langChangesSubscription.unsubscribe();

    // Delete Robots
    const robotTags = this.meta.getTags('name="robots"');
    robotTags.forEach((tag) => {
      try {
        this.meta.removeTagElement(tag);
      } catch (e) {
        console.error(e);
      }
    });

    this.deleteSchemaMeta();
  }

  deleteSchemaMeta() {
    // Delete Hreflang
    const hreflangTags = this.meta.getTags('name="hreflang"');
    hreflangTags.forEach((tag) => {
      try {
        this.meta.removeTagElement(tag);
      } catch (e) {
        console.error(e);
      }
    });

    // Delete Canonical
    try {
      this.meta.removeTag("rel=canonical");
    } catch (e) {
      console.error(e);
    }
  }
}
